<template>
  <Dialog
    :title="type == 'add' ? '新增' : '编辑'"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model.trim="form.name"
          placeholder="2~5个汉字"
          maxlength="5"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input v-model.trim="form.idCard" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model.trim="form.phone" placeholder="请输入"></el-input>
      </el-form-item>

      <!-- <el-form-item v-if="type === 'add'" label="密码" prop="password">
        <el-input
          v-model.trim="form.password"
          show-password
          placeholder="6~14位，仅数字/英文/标点"
        ></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="开始时间" prop="studyStartTime">
        <el-date-picker
          v-model="form.studyStartTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="studyStartPickerOptions"
          style="width: 100%;"
          @change="onStudyStartTimeChange"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="studyEndTime">
        <template #label>
          <span>
            结束时间
            <el-tooltip content="未填写结束日期，默认长期生效">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </span>
        </template>
        <el-date-picker
          v-model="form.studyEndTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="studyEndPickerOptions"
          style="width: 100%;"
        >
        </el-date-picker>
      </el-form-item> -->
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>
<script>
import {
  validateIdCard,
  validatePhone,
  validatePassword,
  validateChineseName,
  validateStudyStartTime,
  createValidateStudyEndTime
} from "@/utils/validate";
import { editData, addData, getStudentInfo } from "@/api/student";

const defaultForm = () => ({
  memberWechatId: "",
  memberCode: "",
  name: "",
  phone: "",
  idCard: "",
  password: "",
  status: 0,
  studyStartTime: "",
  studyEndTime: ""
});

function toDateString(value) {
  if (!value) {
    return "";
  }
  return String(value).slice(0, 10);
}

export default {
  data() {
    return {
      form: defaultForm(),
      dialogVisible: false,

      type: "",
      submitLoading: false
    };
  },
  computed: {
    studyStartPickerOptions() {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      return {
        disabledDate(time) {
          return time.getTime() < todayStart.getTime();
        }
      };
    },
    studyEndPickerOptions() {
      let minDayStart = new Date();
      minDayStart.setHours(0, 0, 0, 0);
      if (this.form.studyStartTime) {
        minDayStart = new Date(this.form.studyStartTime.replace(/-/g, "/"));
        minDayStart.setHours(0, 0, 0, 0);
      }
      const minTime = minDayStart.getTime();
      return {
        disabledDate(time) {
          return time.getTime() < minTime;
        }
      };
    },
    rules() {
      return {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateChineseName, trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validateIdCard, trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" }
        ],
        studyStartTime: [
          { required: true, message: "请选择时间", trigger: "change" },
          { validator: validateStudyStartTime, trigger: "change" }
        ],
        studyEndTime: [
          {
            validator: createValidateStudyEndTime(
              () => this.form.studyStartTime
            ),
            trigger: "change"
          }
        ]
      };
    }
  },
  methods: {
    onStudyStartTimeChange() {
      this.$nextTick(() => {
        if (this.form.studyEndTime && this.$refs.formRef) {
          this.$refs.formRef.validateField("studyEndTime");
        }
      });
    },
    async open(type, id) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        const result = await getStudentInfo(id);
        const data = result.data || {};
        this.form = {
          ...data,
          studyStartTime: toDateString(data.studyStartTime),
          studyEndTime: toDateString(data.studyEndTime)
        };
      } else {
        this.form = defaultForm();
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return false;
      }
      const payload = { ...this.form };
      delete payload.userKey;
      if (this.type === "edit") {
        delete payload.password;
        delete payload.status;
      }
      this.submitLoading = true;
      try {
        await (this.type === "add" ? addData(payload) : editData(payload));
        this.$message.success(this.type === "add" ? "保存成功" : "编辑成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/students/StudentsDialog.vue